<template>
    <div class="flex flex-col gap-[15px]">
        <div>
            <label
                class="relative flex items-start tablet:items-center gap-2 cursor-pointer select-none text-[#7C7C7C] text-[14px] font-medium"
>
                <input
v-model="isChecked" type="checkbox" class="appearance-none w-[30px] h-[30px] border-[1px] border-[#ccc] rounded-[5px] relative
              checked:border-[#A084E8] transition-colors duration-200
             flex items-center justify-center" @change="handleCheck"
>
                <span class="text-[14px] font-roboto font-regular text-[#666666]">Billing Address is the Same as Service
                    Address</span>

                <!-- Checkmark -->
                <div class="absolute top-0 left-0 w-[30px] h-[30px] flex items-center justify-center">
                    <svg
v-if="isChecked" class="w-[20px] h-[20px]  text-[#A084E8] pointer-events-none" fill="none"
                        stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
            </label>
        </div>
        <div v-if="!isChecked">
            <div class="flex flex-col gap-[15px]">
                <div class="grid grid-cols-1">
                    <div class="flex flex-col gap-[3px]">
                        <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="address">Billing
                            Address<span class="ml-1 text-red-500">*</span></label>
                        <GoogleAutoComplete
v-model="selectedBillingAddress.address" placeholder="Address"
                            :input-class="'w-full px-3 py-[6px] !rounded-[10px] outline-none font-roboto text-[16px] placeholder:text-[#CCCCCC] text-[#333]'" @place-selected="handlePlace"
                            @address-reset="resetSelectedAddress"
/>
                        <p v-if="!selectedBillingAddress?.lat && isValidate" class="text-red-500 text-xs mb-0">
This
                            field
                            is required.
</p>
                    </div>
                </div>
                <div class="grid grid-cols-1">
                    <div class="flex flex-col gap-[3px]">
                        <label
class="text-[16px] font-normal font-roboto text-[#666666] w-full"
                            for="customFullName"
>Apt./
                            Unit#<span class="ml-[8px] text-[#999999]">Optional</span></label>
                        <inputComponent
ref="unit" v-model="selectedBillingAddress.address_line2" name="unit" placeholder="Apt./ Unit#"
                            length="120"
                            custom-class="!text-[16px] font-roboto font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]"
/>
                    </div>
                </div>
                <div class="grid grid-cols-1 tablet:grid-cols-2 gap-[15px] tablet:gap-[30px]">
                    <div class="flex flex-col gap-[3px]">
                        <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="city">City<span
                                class="ml-1 text-red-500"
>*</span></label>
                        <inputComponent
ref="city" v-model="selectedBillingAddress.city" disabled name="city" required
                            placeholder="City" error-message="Invalid city"
                            custom-class="!text-[16px] font-roboto font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]"
/>
                    </div>
                    <div class="flex flex-col gap-[3px]">
                        <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="zipCode">Zip
                            Code<span class="ml-1 text-red-500">*</span></label>
                        <inputComponent
ref="zipCode" v-model="selectedBillingAddress.zip_code" disabled name="zipCode" required
                            placeholder="Zip Code" error-message="Invalid zip code"
                            custom-class="!text-[16px] font-roboto font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]"
/>
                    </div>
                </div>
                <div class="grid grid-cols-1">
                    <div class="flex flex-col gap-[3px]">
                        <label class="text-[16px] font-normal font-roboto text-[#666666] w-full" for="state">State<span
                                class="ml-1 text-red-500"
>*</span></label>
                        <inputComponent
ref="state" v-model="selectedBillingAddress.state" disabled name="state" placeholder="State"
                            length="120" error-message="Invalid state"
                            custom-class="!text-[16px] font-roboto font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]"
/>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-center mt-[30px]">
            <button
class="px-[30px] py-[8px] text-[16px] font-roboto rounded-full transition duration-300 border-[1px] border-[#00B7C2] text-[#00B7C2] hover:bg-[#00B7C2] hover:text-[#fff] [@media(max-width:1023px)]:!bg-[#00B7C2] [@media(max-width:1023px)]:!text-[#fff]"
                @click="submitForm"
>
Continue
                to Payment
</button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import inputComponent from '../../partialComponent/inputComponent.vue';
import GoogleAutoComplete from '../../partialComponent/GoogleAutoComplete.vue';
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    components: {
        inputComponent,
        GoogleAutoComplete
    },
    emits: ["submitDetail"],

    data() {
        return {
            isValidate: false,
            isChecked: true,
            selectedBillingAddress: {
                "address": null,
                "address_line1": null,
                "address_line2": null,
                "city": null,
                "state": null,
                "zip_code": null,
                "country": null,
                "lat": null,
                "lng": null
            },
        };
    },

    computed: {
        ...mapGetters([
            "formattedAddress",
        ]),

    },

    watch: {
        formattedAddress: function (data) {
            this.selectedBillingAddress = {
                "address": this.formattedAddress.address_1,
                "address_line1": this.formattedAddress.street,
                "address_line2": this.formattedAddress.address_2,
                "city": this.formattedAddress.city_id,
                "state": this.formattedAddress.state_id,
                "zip_code": this.formattedAddress.postal_code,
                "country": this.formattedAddress.country_name,
                "lat": this.formattedAddress.lat,
                "lng": this.formattedAddress.long
            }
        },
    },

    methods: {
        ...mapActions([
            "getFormattedAddress",
        ]),

        setData(data) {
            this.isValidate = false
            this.isChecked = (data.is_billing_address_same == 1)
            this.resetSelectedAddress()
            if (data.billing_address) {
                this.selectedBillingAddress = data.billing_address
            }
        },

        reset() {
            this.isChecked = true
            this.resetSelectedAddress()
        },

        handleCheck() {
            this.resetSelectedAddress()
        },

        resetSelectedAddress() {
            this.isValidate = false
            this.selectedBillingAddress = {
                "address": null,
                "address_line1": null,
                "address_line2": null,
                "city": null,
                "state": null,
                "zip_code": null,
                "country": null,
                "lat": null,
                "lng": null
            }
        },

        handlePlace(place) {

            this.getFormattedAddress({
                address: place.formatted_address,
                lat: place.geometry?.location?.lat(),
                lng: place.geometry?.location?.lng(),
            })
        },

        validateForm() {
            let hasError = false;
            this.isValidate = true
            if (!this.isChecked && (this.selectedBillingAddress?.lat ?? 0) == 0) {
                hasError = true;
            }
            return hasError;
        },

        submitForm() {

            if (!this.validateForm()) {
                let formData = {
                    is_billing_address_same: this.isChecked ? 1 : 0,
                    billing_address: this.selectedBillingAddress
                }
                this.$emit('submitDetail', formData);
            }
        }


    }
};
</script>
